var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2V5.60944H14.92C14.806 5.60944 14.4215 5.66874 14.3017 5.70286C14.0044 5.78788 13.8382 5.9842 13.7448 6.26667C13.6124 6.66604 13.5826 8.30045 13.6365 8.74904C13.6439 8.80889 13.6416 8.85476 13.7018 8.89055H17L16.6218 12.5H13.6388V23H9.18485V12.5H7V8.89055H9.16365C9.22381 8.85476 9.22152 8.80889 9.22897 8.74904C9.3281 7.92625 9.17224 6.8937 9.22496 6.03846C9.37337 3.63105 10.8013 2.10516 13.3196 2.03804L13.3861 2H17Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.3fdf980f54464868ec6db92a39e9cca9.svg";
export { ForwardRef as ReactComponent };